import React, { useState, useContext, useEffect } from "react"
import useWhatMenuShow from "@hooks/useWhatMenuShow"
import LanguageContext from "@context/LanguageContext"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"
import Triangle from "@images/triangle.svg"

export default ({
  textColor,
  subMenuBackgroundColor,
  subMenuTextColor,
  arrowIcon,
  forceToShowTabletMenu,
}) => {
  const whatMenuShow = useWhatMenuShow(forceToShowTabletMenu)
  const isMobileOrTablet = whatMenuShow !== "desktop"

  const [isOpened, setOpened] = useState(!isMobileOrTablet)
  const { t } = useTranslation()
  if (!isOpened && !isMobileOrTablet) {
    setOpened(!isMobileOrTablet)
  }

  const context = useContext(LanguageContext)

  const arrAvailableLanguages = context.availableLanguages

  //Every time isMobile and isTablet changes we need to update the state
  useEffect(() => {
    setOpened(!isMobileOrTablet)
  }, [whatMenuShow])

  const toggleState = () => {
    // Keep it open always in desktop resolution
    setOpened(!isOpened)
  }

  let elements = [
    {
      lang: "en",
      title: "English",
      url: "/",
    },
    {
      lang: "de",
      title: "Deutsch",
      url: "/de",
    },
    {
      lang: "es",
      title: "Español",
      url: "/es",
    },
  ]

  if (arrAvailableLanguages.length > 3) {
    elements = arrAvailableLanguages.map(lang => {
      return {
        lang,
        title: t(lang + "_language"),
        url: `/${lang === "en" ? "" : lang}`,
      }
    })
  }

  const url_actual = useLocation()

  let pathName = url_actual.pathname

  const elementsUrl = elements
    .map(element => element.url)
    .filter(url => url !== "/")

  if (elementsUrl.some(url => pathName.startsWith(url))) {
    pathName = pathName.substring(4)
  } else {
    pathName = pathName.substring(1)
  }

  if (!pathName.endsWith("/") && pathName.length > 0) {
    pathName += "/"
  }

  const newElements = elements.map((element, index) => {
    if (index === 0) {
      return { ...element, url: element.url + pathName }
    } else {
      return { ...element, url: element.url + "/" + pathName }
    }
  })

  const titleForMobile =
    elements.find(item => item.url.startsWith(`/${context.language}`))?.title ||
    "ENGLISH"

  const actLang = context.language.toLowerCase()
  const actLangLabel =
    whatMenuShow !== "desktop" ? titleForMobile : context.language.toUpperCase()

  const handleClick = lng => {
    let usedLng = lng
    if (lng === "es") {
      usedLng = "es"
    } else if (lng === "de") {
      usedLng = "de"
    } else {
      usedLng = "en"
    }
    localStorage.setItem("lastChosenLanguage", usedLng)
  }

  return (
    <div className="group relative">
      <div className="flex justify-between" onClick={toggleState}>
        <span
          className={`
            block no-underline ${textColor} px-6 ${
            isMobileOrTablet && isOpened ? "pt-3 pb-1" : "py-3"
          }  uppercase text-xs font-semibold font-inter cursor-default hover:text-mgreen tracking-[0.16px]
          
          ${whatMenuShow !== "mobile" && "md:text-tiny"}
          ${
            whatMenuShow === "desktop" &&
            "desk:px-3 desk:py-5  fhd:text-base desk:text-[16px] desk:pr-[4px]"
          }
          `}
        >
          {actLangLabel}
        </span>
        {!isMobileOrTablet && (
          <img
            src={Triangle}
            alt="triangle"
            className={`
              px-6 py-4 uppercase text-xs font-bold
              
              ${whatMenuShow !== "mobile" && "md:px-3 md:py-5  md:text-tiny "}
              
              ${whatMenuShow === "desktop" && "fhd:text-base "}
              
              `}
            style={{
              verticalAlign: "middle",
              float: "right",
              paddingLeft: "0px",
            }}
          />
        )}
        {isMobileOrTablet && (
          <img
            src={arrowIcon}
            alt="arrow down"
            className={`${whatMenuShow === "desktop" && "desk:hidden"} mr-6 ${
              isOpened ? "rotate-180" : ""
            }`}
          />
        )}
      </div>
      <div
        className={`group-hover:flex ${isOpened ? "block" : "!hidden"} 
        
        ${
          whatMenuShow === "desktop" &&
          "desk:hidden desk:absolute desk:left-[-50px] desk:w-64"
        }
        
        `}
      >
        <div
          className={`
            flex flex-col mr-6 ml-6 pb-4 pt-0 w-full ${subMenuBackgroundColor} 
            
             ${
               whatMenuShow === "desktop" &&
               "desk:px-9 desk:py-5 desk:mt-[15px] desk:border-none"
             }
            `}
        >
          <div
            className={`     
              
              hidden  absolute ${subMenuBackgroundColor} rotate-45 w-3 h-3 top-[9px]
              
              ${whatMenuShow === "desktop" && "desk:block"}
     
              `}
          ></div>
          {(newElements || []).map(
            (e, i) =>
              (!isMobileOrTablet ||
                (isMobileOrTablet && e.lang !== actLang)) && (
                <Link
                  onClick={() => handleClick(e.lang)}
                  to={e.url}
                  className="py-1 desk:py-2"
                  key={`complex-menu-item-${i}`}
                >
                  <span
                    className={`${subMenuTextColor} text-sm font-inter

                       ${
                         whatMenuShow === "desktop" &&
                         "desk:text-base desk:uppercase desk:font-bold"
                       }`}
                  >
                    {e.title}
                  </span>
                </Link>
              )
          )}
        </div>
      </div>
    </div>
  )
}
